var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 22.5C44 34.3741 34.3741 44 22.5 44C10.6259 44 1 34.3741 1 22.5C1 10.6259 10.6259 1 22.5 1C34.3741 1 44 10.6259 44 22.5Z",
    fill: "white",
    stroke: "#F89144",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5564 35.909C38.4579 33.0996 35.7331 30.8184 32.5985 29.2466C29.4639 27.6748 26.0059 26.8558 22.4993 26.8547C18.9927 26.8536 15.5341 27.6704 12.3985 29.2403C9.26295 30.8101 6.53672 33.0896 4.43652 35.8977C6.52604 38.7201 9.24782 41.0135 12.3836 42.5942C15.5194 44.1749 18.9819 44.9988 22.4936 44.9999C26.0052 45.001 29.4683 44.1793 32.6051 42.6005C35.7419 41.0218 38.4651 38.7301 40.5564 35.909Z",
    fill: "url(#paint0_linear_1614_129)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5007 23.9518C27.3109 23.9518 31.2104 20.0524 31.2104 15.2421C31.2104 10.4319 27.3109 6.53247 22.5007 6.53247C17.6905 6.53247 13.791 10.4319 13.791 15.2421C13.791 20.0524 17.6905 23.9518 22.5007 23.9518Z",
    fill: "url(#paint1_linear_1614_129)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1614_129",
    x1: 40.2631,
    y1: 26.5663,
    x2: 29.9232,
    y2: 51.0491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF3438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1614_129",
    x1: 31.069,
    y1: 6.25562,
    x2: 17.427,
    y2: 22.4825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF3438"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.23cc34d47cd08c1dc4d3b56c42a5c380.svg";
export { ForwardRef as ReactComponent };